import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';

import { usePrevious, useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';
import { Node } from '@uncinc/react-drupal-core';

import Pager from '../../../../components/Pager';

import { SCREEN_TABLET } from '../../../../config/constants';
import './style.scss';

const NAVBAR_SCROLL_OFFSET = 200;
const OVERVIEW_TYPES = {
  articles: 'articles',
  vacancies: 'vacancies',
  activities: 'activities',
  activities_pinned: 'activities_pinned',
};

const ViewRecentContentOverviewRegenboog = ({ entities, pager, page, setCurrentPage, noPagination = false, filters, resetFilters, display, loading }) => {
  const { t } = useTranslation();

  const ref = useRef(null);
  const totalPages = pager.get('total_pages');
  const previousFilters = usePrevious(filters);

  // Reset page when filters change.
  useEffect(() => {
    if (JSON.stringify(previousFilters) !== JSON.stringify(filters) && setCurrentPage) {
      setCurrentPage(0);
    }
    // Do not add more dependencies to this hook.
    // This will cause rendering issues with the pager.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, previousFilters]);

  useEffect(() => {
    // We skip activities_pinned specifically because it loaded inside another view,
    // else the scroll will be triggered twice.
    if (ref.current && !loading && display !== OVERVIEW_TYPES.activities_pinned) {
      let top;
      // Try to query the paragraph containing this block.
      // This way we can scroll to a point including all the extra chrome.
      const paragraph = document.querySelector(`.ParagraphContentOverview:has([view-block-id=views_block__content_overview_${display}])`);
      if (paragraph) {
        top = paragraph.getBoundingClientRect().top;
      // Fallback to just scrolling to the top off the view.
      } else {
        top = ref.current.getBoundingClientRect().top;
      }
      top += window.pageYOffset - NAVBAR_SCROLL_OFFSET;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }, [loading, display]);


  const ViewClasses = c('ViewRecentContentOverview', {
    'ViewRecentContentOverview--no-pager': totalPages <= 1,
    'ViewRecentContentOverview--loading': loading,
  });

  const { width } = useWindowDimensions();
  const isTypeActivitiesPinned = display === OVERVIEW_TYPES.activities_pinned;

  return (
    entities.size > 0 ? (
      <div className={ViewClasses} ref={ref}>
        {/* Start of items */}
        <div className="row">
          {entities.map((entity, index) => {
            const id = entity.getIn(['nid', 0, 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);

            return (
              <div key={uuid} className={`col-12 ${index < 2 && isTypeActivitiesPinned && page === 0 ? '' : 'col-md-6 col-lg-4'}`}>
                <Node
                  id={id}
                  entity={entity}
                  viewMode="teaser"
                  wide={isTypeActivitiesPinned && page < 1}
                  flipped={isTypeActivitiesPinned && width >= SCREEN_TABLET && index === 1}
                  activeFilters={filters}
                />
              </div>
            );
          })}
        </div>
        {/* End of items */}

        {/* Start of Pager */}
        {!noPagination && (
          <div className="ViewRecentContentOverview__pager">
            <Pager currentPage={page} totalPages={totalPages} setCurrentPage={setCurrentPage} />
          </div>
        )}
        {/* End of Pager */}
      </div>
    ) : (
      <div className={c('View__no_results', { loading })}>
        {loading ? (
          <div className="View__no_results__title">
            <span>{t('filters.loading')}</span>
          </div>
        ) : (
          <>
            <div className="View__no_results__title">
              <strong>{t('filters.no_results.title')}</strong>
              <br />
              { display === 'block_9' ? <span>{t('filters.no_results.text_daytime_activities')}</span> : <span>{t('filters.no_results.text')}</span> }
            </div>
            {resetFilters && (
              <button
                type="button"
                className="Button Button--primary"
                onClick={resetFilters}
              >
                {t('filters.reset')}
              </button>
            )}
          </>
        )}
      </div>
    )
  );
};

export default ViewRecentContentOverviewRegenboog;
